/**
 * CompetitorXrefTable — Cross-reference table showing competitor part numbers
 * Displays all 7 manufacturers with em-dash fallback for empty values.
 */
export default function CompetitorXrefTable({ product, manufacturers }) {
  return (
    <div className="px-4 py-4">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-n1">
            <th className="text-left py-3 px-4 font-normal text-carbon-black font-sandvik-headline text-sm">
              Manufacturer
            </th>
            <th className="text-left py-3 px-4 font-normal text-carbon-black font-sandvik-headline text-sm">
              Part number
            </th>
          </tr>
        </thead>
        <tbody>
          {manufacturers.map((mfr, index) => (
            <tr
              key={mfr.key}
              className={index % 2 === 0 ? 'bg-white' : 'bg-n1'}
            >
              <td className="py-3 px-4 text-n7 font-sandvik-text text-sm">
                {mfr.name}
              </td>
              <td className="py-3 px-4 text-carbon-black font-sandvik-text text-sm">
                {product[mfr.key] || '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
